import React from 'react';
import { EntityId, IconButton_IconSizes, Row, Text } from '@ydistri/ds';
import SimpleList from './SimpleList';
import YLink from '../../../../../components/global/Link/YLink';
import { generatePath } from 'react-router';
import { ROUTES } from '../../../../../components/menu/getMenuLeftItems';
import { MdOpenInNew } from 'react-icons/md';
import { useStableParams } from '../../../../../routes/useStableParams';
import { CategoryTreeNode } from '../../../../../lib/categories/categoryTypes';
import { useClipboardHandlers } from '../../../../../lib/hooks/useClipboardHandlers';

interface CategoriesListProps {
  categories: CategoryTreeNode[];
}

/**
 * List of categories with their customer category id
 * @param categories
 * @constructor
 */
const CategoriesList: React.FC<CategoriesListProps> = ({ categories }) => {
  const { projectShortName } = useStableParams();
  const clipboardHandlers = useClipboardHandlers();

  return (
    <SimpleList
      values={categories.map(category => {
        const path = generatePath(ROUTES.detail, {
          projectShortName: projectShortName ?? '',
          slug: category.slug,
        });

        return (
          <Row $gap="0.6rem" $alignItems="center" key={category.id}>
            <YLink to={path}>
              <Row $gap="0.6rem" $alignItems="center">
                <Text>{category.title}</Text>
                <MdOpenInNew size={IconButton_IconSizes.xSmall} />
              </Row>
            </YLink>
            {category.customerCategoryId && (
              <EntityId
                id={category.customerCategoryId}
                code={category.code}
                systemId={category.id}
                {...clipboardHandlers}
              />
            )}
          </Row>
        );
      })}
    />
  );
};

export default CategoriesList;
